import React from "react";
import CustomChip from "../../../../components/CustomChip";
import { ArrowAccordionIcon, ArrowAccordionUpIcon } from "../../../../components/buttons/IconButtons";
import NotInformation from "../../../../components/NotInformation";
import GroupedCardApp from "../Functionality/GroupedCardApp";
import { AREA_EMPTY_TRANS } from "../Model/Model";
import EventFeedRow from "./EventFeedRow";
import PanelLoading from "./PanelLoading";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Group of the zone overview: zone name, events of today and its critical / warning counters.
 * Expanding it shows its accesses and the critical and warning logs of its controllers, read by pages
 * while its list is scrolled.
 *
 * @param {Object} group - Area with its counters and the events it read.
 * @param {number} now - Current timestamp, refreshes the elapsed time.
 * @param {Function} onLoadMore - Reads the next page of events of the area.
 */
const GroupedCard = ({ group, now, onLoadMore }) => {
    const { t, expanded, toggleExpanded, badges, feed, listRef, loadMoreIfNeeded } = GroupedCardApp({ group, onLoadMore });

    return (
        <div className='p-16px border-full-shades-100 border-radius-8px background-shades-50'>
            <div
                id={`div_gc_toggle_${group.id}`}
                className='d-flex align-items-center justify-content-between cursor-pointer'
                onClick={toggleExpanded}
            >
                <p className='fs-12px ibl-font-w-600 font-color-general-950'>{group.name}</p>
                {expanded
                    ? <ArrowAccordionUpIcon className='btn-icon-svg-24px icon-color-shades-400' />
                    : <ArrowAccordionIcon className='btn-icon-svg-24px icon-color-shades-400' />
                }
            </div>
            <div className='d-flex align-items-center justify-content-between gap-2 mt-1'>
                <p className='fs-12px ibl-font-w-400 font-color-shades-950'>{t('x_events', { total: group.total })}</p>
                <div className='d-flex align-items-center gap-2'>
                    {badges.map((badge) => (
                        <CustomChip
                            key={badge.key}
                            legend={t(badge.legend, { total: badge.total })}
                            background={badge.severity.BACKGROUND}
                            fontColor={badge.severity.FONT}
                            borderColor={badge.severity.BORDER}
                        />
                    ))}
                </div>
            </div>
            {expanded &&
                <div
                    ref={listRef}
                    onScroll={loadMoreIfNeeded}
                    className='event-monitoring-area-events custom-scrollbar mt-3 border-radius-8px'>
                    {feed.loaded && feed.events.length === 0 &&
                        <NotInformation text={t(AREA_EMPTY_TRANS)} card={true} className='event-monitoring-area-not-information' />
                    }
                    {feed.events.map((event) => (
                        <EventFeedRow key={event.id} event={event} now={now} />
                    ))}
                    {feed.loading && <PanelLoading />}
                </div>
            }
        </div>
    );
};

export default GroupedCard;
